import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetJobEditedSuccessLink(jobId: string) {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/jobs/${jobId}/edit-job-success`;
}
